(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/hooks/assets/javascripts/use-locked-draw.js') >= 0) return;  svs.modules.push('/components/tipsen/hooks/assets/javascripts/use-locked-draw.js');
"use strict";

const TipsenModuleGameUrl = svs.components.sport.tipsenShared.TipsenModuleGameUrl;
const _ReactRouterDOM = ReactRouterDOM,
  useLocation = _ReactRouterDOM.useLocation;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const selectActiveWallet = svs.components.tipsen.walletSelectors.selectActiveWallet;
const _svs$components$tipse = svs.components.tipsen.wallet.walletType,
  WALLET_MARKETPLACE_PLAYER = _svs$components$tipse.WALLET_MARKETPLACE_PLAYER,
  WALLET_MARKETPLACE_RETAILER = _svs$components$tipse.WALLET_MARKETPLACE_RETAILER;
const marketplaceWalletTypes = [WALLET_MARKETPLACE_PLAYER, WALLET_MARKETPLACE_RETAILER];
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const useLockedDraw = () => {
  const location = useLocation();
  const isExternalInspect = location.pathname.includes("/".concat(TipsenModuleGameUrl.EXTERNAL, "/granska"));
  const selectedWallet = useSelector(selectActiveWallet);
  const isMarketplaceWallet = selectedWallet && marketplaceWalletTypes.includes(selectedWallet.type);
  const shouldLockDraw = isExternalInspect || isMarketplaceWallet;
  const draw = useCurrentDraw();
  return shouldLockDraw ? {
    productId: draw === null || draw === void 0 ? void 0 : draw.productId,
    drawNumber: draw === null || draw === void 0 ? void 0 : draw.drawNumber
  } : null;
};
setGlobal('svs.components.tipsen.hooks.useLockedDraw', useLockedDraw);

 })(window);